import Lenis from '@studio-freight/lenis'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { debounce } from './debounce'

export let lenis = null

const registerLenis = () => {
    lenis = new Lenis({
        duration: 1.3,
        easing: (t) => (t === 1 ? 1 : 1 - Math.pow(2, -10 * t)),
        direction: 'vertical',
        gestureDirection: 'vertical',
        smooth: true,
        smoothTouch: false,
        touchMultiplier: 2,
    })

    lenis.on('scroll', () => {
        ScrollTrigger.update()
    })

    function raf(time) {
        if (lenis) lenis.raf(time)
        requestAnimationFrame(raf)
    }
    requestAnimationFrame(raf)
}

if (window.innerWidth > 1024) {
    registerLenis()
}
